// import React from "react";
// import UseGetDashBoardDataPro from "../../../../Components/Hooks/UseGetDashBoardDataPro";


// const ProjectStatus = () => {
//   const { data, loading } = UseGetDashBoardDataPro(`/Dashboard/projects/status`);

//   return (
//     <div className="bg-white p-4 rounded-lg drop-shadow-lg h-[45vh]  2xl:h-[35vh] w-full">
//       <h2 className="text-sm font-semibold text-[#4F4768]">Project Status</h2>
//       <div className="w-full h-[96%] overflow-y-scroll pb-4">
//           <table className="w-full">
//             <thead className="sticky top-0 bg-white shadow-sm">
//                 <tr className="border-b text-left">
//                 <th className="p-2 text-xs font-semibold text-[#4F4768]">Project</th>
//               <th className="p-2 text-xs font-semibold text-[#4F4768]">Status</th>
//               <th className="p-2 text-xs font-semibold text-[#4F4768]">Start Date</th>
//               <th className="p-2 text-xs font-semibold text-[#4F4768]">End Date</th>
//               <th className="p-2 text-xs font-semibold text-[#4F4768]">Remaining</th>
//               <th className="p-2 text-xs font-semibold text-[#4F4768]">Plan</th>
//               <th className="p-2 text-xs font-semibold text-[#4F4768]">Actual</th>
//             </tr>
//           </thead>
//           <tbody>
//             {data?.projects?.map((project, index) => (
//               <tr key={index} className="border-b">
//                 <td className="p-2 text-xs font-normal  items-center">
                 
//                   {project.name}
//                   <div className="flex gap-2 items-center">
//                   <div className="w-20 h-1 bg-gray-300 rounded-full  relative">
//                     <div className="w-3/4 h-1 bg-blue-500 rounded-full"></div>
//                   </div>
//                   <div>
//                   {project.progress && (
//                     <span className={` font-normal ${project.progressColor}`}>
//                       {project.progress}
//                     </span>
//                   )}</div>
//                   </div>
//                 </td>
//                 <td className={`p-2 text-xs font-normal  ${project.statusColor}`}>
//                   {project.status}
//                 </td>
//                 <td className="p-2 text-xs font-normal">{project.startDate}</td>
//                 <td className="p-2 text-xs font-normal">{project.endDate}</td>
//                 <td className="p-2 text-xs font-normal">{project.remaining}</td>
//                 <td className="p-2 text-xs font-normal">{project.plan}</td>
//                 <td className="p-2 text-xs font-normal ">
                  
//                   {project.actual}
//                 </td>
//               </tr>
//             ))}
//           </tbody>
//         </table>
//       </div>
//     </div>
//   );
// };

// export default ProjectStatus;

import React from "react";
import UseGetDashBoardDataPro from "../../../../Components/Hooks/UseGetDashBoardDataPro";

const ProjectStatus = () => {
  const { data, loading } = UseGetDashBoardDataPro(`/Dashboard/projects/status`);

  const formatDate = (dateString) => {
    if (!dateString) return "-";
    const date = new Date(dateString);
    return date.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  };

  const getStatusColor = (status) => {
    switch (status.toLowerCase()) {
      case "yet to start":
        return "text-yellow-500";
      case "in progress":
        return "text-blue-500";
      case "completed":
        return "text-green-500";
      case "on hold":
        return "text-red-500";
      default:
        return "text-gray-500";
    }
  };

  return (
    <div className="bg-white p-4 rounded-lg drop-shadow-lg h-[45vh] 2xl:h-[35vh] w-full">
      <h2 className="text-sm font-semibold text-[#4F4768]">Project Status</h2>
      <div className="w-full h-[96%] overflow-y-scroll pb-4">
          <table className="w-full">
            <thead className="sticky top-0 bg-white shadow-sm">
                <tr className="border-b text-left">
               <th className="p-2 text-xs font-semibold text-[#4F4768]">Project</th>
              <th className="p-2 text-xs font-semibold text-[#4F4768]">Status</th>
              <th className="p-2 text-xs font-semibold text-[#4F4768]">Start Date</th>
              <th className="p-2 text-xs font-semibold text-[#4F4768]">End Date</th>
              <th className="p-2 text-xs font-semibold text-[#4F4768]">Remaining</th>
            </tr>
          </thead>
          <tbody>
            {data?.projects?.map((project, index) => (
              <tr key={index} className="border-b">
                <td className="p-2 text-xs font-normal">{project.name}
                <div className="flex gap-2 items-center">
                   <div className="w-20 h-1 bg-gray-300 rounded-full  ">
                     <div className="w-3/4 h-1 bg-blue-500 rounded-full"></div>
                   </div>
                   <div>
                   {project.progress && (
                     <span className={` font-normal ${project.progressColor}`}>
                       {project.progress}
                     </span>
                   )}</div>
                   </div>
                </td>
                <td className={`p-2 text-xs font-normal ${getStatusColor(project.status)}`}>
                  {project.status}
                </td>
                <td className="p-2 text-xs font-normal">{formatDate(project.start_date)}</td>
                <td className="p-2 text-xs font-normal">{formatDate(project.end_date)}</td>
                <td className="p-2 text-xs font-normal">{project.remaining}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ProjectStatus;
